module.exports = __webpack_public_path__ + "media/assets/images/iconmonstr-candy-6-5fbc1931c549aec2030bd8da499036b4.svg";